import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { MDBModalRef, MDBModalService, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { Formio, Form, Utils } from '@atefhashem/eforms';
import { loopOnComponents } from 'app/helpers/utils';
import { FieldsPickerModalComponent } from '../fields-picker-modal/fields-picker-modal.component';

@Component({
  selector: 'app-fields-picker',
  templateUrl: './fields-picker.component.html',
  styleUrls: ['./fields-picker.component.scss']
})
export class FieldsPickerComponent implements OnInit {

  @Input() multi: boolean = true;
  @Input() prePickRequired: boolean = true;
  @Input() fieldTypeFilter: string[] = null;

  private pickedFields: string[] = [];

  uniqueID: string = '';

  modalRef: MDBModalRef;
  
  @Output() finishedPicking: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() pickerClosed: EventEmitter<any> = new EventEmitter<any>();
  constructor(private toastService: ToastService, private modalService: MDBModalService) { }

  ngOnInit(): void {
    this.uniqueID =  Math.random().toString(36).substr(2, 9);
    this.modalService.closed.subscribe(() => this.onModalClose());
  }

  public onModalClose() {   
    // clean up
    //document.getElementById('picker_eform_' + this.uniqueID).innerHTML = "";
    this.pickerClosed.emit();
  }
  public onModalOK() {
    this.finishedPicking.emit(this.pickedFields);
    this.modalRef.hide();
  }

  /**
   * 
   * @param form 
   * @param prePickedFields Pre-pick the fields by component key. If null, then default (required ones) are picked, if empty array then nothing is picked.
   */
  public showPicker(form: any, prePickedFields: string[] = null) {
    this.modalRef = this.modalService.show(FieldsPickerModalComponent, {
      ignoreBackdropClick: true,
      backdrop: true,
      animated: true,
      containerClass: 'modal fade',
      class: 'modal-primary modal-fluid max-w-1400 p-2',
      data: {
        multi: this.multi,
        pickedFields: this.pickedFields,
        uniqueID: this.uniqueID,
        form: JSON.parse(JSON.stringify(form)), // fastCloneDeep
        prePickedFields: prePickedFields,
        prePickRequired: this.prePickRequired,
        fieldTypeFilter: this.fieldTypeFilter
      }
    });

    this.modalRef.content.pickedFieldsSubject.subscribe((f: string[]) => {
      this.pickedFields = f;
      this.onModalOK();
    });
    
  }
}
